import React from 'react';

const BotSelection = ({ botTypes, selectedBotType, onSelectBotType }) => {
    if (!botTypes || botTypes.length === 0) {
      return (
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-5 flex items-center group">
            <div className="w-10 h-10 rounded-lg bg-accent-purple/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
              <i className="fas fa-robot text-accent-purple"></i>
            </div>
            Bot Selection
          </h2>
          <p className="text-gray-400">No bot types available</p>
        </div>
      );
    }
  
    return (
      <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
        <h2 className="text-2xl font-bold mb-5 flex items-center group">
          <div className="w-10 h-10 rounded-lg bg-accent-purple/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
            <i className="fas fa-robot text-accent-purple"></i>
          </div>
          Bot Selection
          <div className="ml-3 text-xs py-1 px-2 bg-accent-purple/20 rounded-full text-accent-purple opacity-0 group-hover:opacity-100 transition-medium">
            3 types available
          </div>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {botTypes.map((bot) => (
            <div
              key={bot.id}
              className={`bg-dark-600 gradient-bg-${bot.accentColor} rounded-2xl p-6 hover:shadow-lg transition gradient-border cursor-pointer relative overflow-hidden group transform-gpu hover:-translate-y-1 hover:shadow-glow active:translate-y-0 active:shadow-inner`}
              onClick={() => onSelectBotType(bot.id)}
            >
              {/* Background glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-accent-pink/10 to-accent-purple/10 rounded-xl blur opacity-0 group-hover:opacity-100 transition-medium"></div>

              <div className="relative z-10 flex items-center mb-4">
                <div className={`w-14 h-14 rounded-xl bg-accent-${bot.accentColor} bg-opacity-20 flex items-center justify-center mr-4 transition-medium transform-gpu group-hover:scale-110 group-hover:rotate-3`}>
                  <i className={`fas fa-${bot.icon} text-accent-${bot.accentColor} text-xl`}></i>
                  {bot.id === 'op-bot' && (
                    <div className={`absolute top-0 right-0 w-4 h-4 bg-accent-${bot.accentColor} rounded-full flex items-center justify-center`}>
                      <i className="fas fa-star text-dark-800 text-[8px]"></i>
                    </div>
                  )}
                </div>
                <div>
                  <h3 className="text-lg font-bold group-hover:text-white transition-medium">{bot.name}</h3>
                  <p className="text-sm text-gray-400 group-hover:text-gray-300 transition-medium">
                    {bot.id === 'op-bot' && 'Gain operator privileges'}
                    {bot.id === 'crash-bot' && 'Test server stability'}
                    {bot.id === 'account-bot' && 'Find account passwords'}
                  </p>
                </div>
              </div>

              <div className="relative z-10 space-y-3"> {/* Removed mb-5 */}
                <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium">{bot.description}</p>

                <div className="flex justify-between text-sm group-hover:scale-105 transition-medium">
                  <span className="text-gray-400 group-hover:text-white transition-medium">Success Rate:</span>
                  <div className="flex items-center">
                    <div className="w-20 h-2 bg-dark-400 rounded-full overflow-hidden mr-2">
                      <div
                        className={`h-full bg-accent-${bot.accentColor} transition-all duration-500 ease-out`}
                        style={{ width: `${bot.successRate}%` }}
                      ></div>
                    </div>
                    <span className={`text-accent-${bot.accentColor} group-hover:opacity-100 opacity-90 transition-medium`}>{bot.successRate}%</span>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              <div className="absolute top-4 right-4 transition-medium transform-gpu group-hover:scale-110">
                <div className={`w-6 h-6 rounded-full border-2 border-accent-${bot.accentColor} flex items-center justify-center ${selectedBotType === bot.id ? `bg-accent-${bot.accentColor}/20` : ''}`}>
                  {selectedBotType === bot.id && (
                    <div className={`w-3 h-3 rounded-full bg-accent-${bot.accentColor}`}></div>
                  )}
                </div>
              </div>

              {/* Corner flourish */}
              <div className="absolute -bottom-4 -right-4 w-16 h-16 opacity-10 bg-white rounded-full blur-xl group-hover:opacity-20 transition-medium"></div>
            </div>
          ))}
        </div>
      </div>
    );
  };

export default BotSelection;
